import { api } from './apiClient';
import {
  CatalogueResponse,
  MyModules,
  PricingBreakdown,
  BillingCycle,
  NavOverrides,
} from '../types/modules';

/**
 * Typed client for the module marketplace — `/api/v1/modules`.
 *
 * Mirrors erp-api/src/controllers/modules.js. Every apiClient verb auto-unwraps
 * `{status, data}` to `data` (see apiClient.ts).
 */
const moduleCatalogueService = {
  /** The full catalogue + bundles (product surface; any authenticated user). */
  getCatalogue: () => api.get<CatalogueResponse>('/modules/catalogue'),

  /** This tenant's enabled set, plan, billing cycle and current pricing. */
  getMyModules: () => api.get<MyModules>('/modules/mine'),

  /** Price a hypothetical selection — drives the live pricing rail. */
  getPricing: (modules: string[], cycle: BillingCycle) =>
    api.post<{ pricing: PricingBreakdown }>('/modules/pricing', { modules, cycle }),

  /** Save a new selection (SUPER_ADMIN / ADMIN). Takes effect immediately. */
  updateMyModules: (modules: string[], cycle: BillingCycle) =>
    api.put<MyModules>('/modules/mine', { modules, cycle }),

  /** Relocate nav items between sections (SUPER_ADMIN / ADMIN). Immediate. */
  updateNavOverrides: (overrides: NavOverrides) =>
    api.put<{ navOverrides: NavOverrides }>('/modules/nav-overrides', { overrides }),
};

export default moduleCatalogueService;
